import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Account } from '../types/Account'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import { deleteAccount } from '../service/accountService'
import accountQueryKeys from './accountQueryKeys'

export const useDeleteAccount = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (code: Account['code']) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }
      return deleteAccount(companyId, code)
    },
    onSuccess: (_data, code) => {
      queryClient.setQueryData(accountQueryKeys.list({ companyId }), (oldItems?: Account[]) =>
        oldItems ? oldItems.filter(item => item.code !== code) : oldItems
      )
    },
    onError: error => {
      console.error('Failed to delete account:', error)
    }
  })
}
